import React from 'react';
import { Link } from 'react-router-dom';
import { TradingPost } from '../../types/TradingTypes';
import '../../assets/styles/TradingBlog.css';

interface TradingPostCardProps {
  post: TradingPost;
}

const TradingPostCard: React.FC<TradingPostCardProps> = ({ post }) => {
  // Sum all trades' profit
  const totalProfit = post.trades.reduce((sum, trade) => sum + trade.profit, 0);
  // Use the first screenshot as the image, or a default
  const image = post.screenshots && post.screenshots.length > 0 ? post.screenshots[0] : '/images/blog/default.jpg';

  return (
    <Link to={`/trading/${post.id}`} className="trading-post-card clickable" style={{ textDecoration: 'none', color: 'inherit' }}>
      <img 
        src={image} 
        alt={post.title} 
        className="trading-post-card-image"
        onError={(e) => {
          (e.target as HTMLImageElement).src = '/images/blog/default.jpg';
        }}
      />
      <div className="trading-post-card-content">
        <h3 className="trading-post-card-title">{post.title}</h3>
        <p className="trading-post-card-profit">Total Profit: ${totalProfit.toFixed(2)}</p>
      </div>
    </Link>
  );
};

export default TradingPostCard; 